export function init() {
	const element = document.querySelector('.js-navbar');
	const activeClass = 'is-active';

	if (!element) {
		return;
	}

	let active = { link: undefined, section: undefined };

	document.documentElement.style.scrollPaddingTop = `${element.clientHeight}px`;

	const links = Array.from(document.querySelectorAll('.js-navbar-link'));

	let items = links.map(element => ({
		link: element,
		section: document.querySelector(element.hash),
	}));

	console.log(items);

	document.addEventListener('scroll', function handleScroll() {
		let results = items
			.map(item => ({ ...item, rect: item.section.getBoundingClientRect() }))
			.filter(item => inView(item.rect))
			.sort((a, b) => a.rect.top - b.rect.top);

		if (!results.length) {
			clearActive();
			return false;
		}

		let lastItem = results[results.length - 1];

		if (active.section && active.section !== lastItem.section) {
			clearActive();
		}

		active.section = lastItem.section;
		active.section.classList.add(activeClass);

		active.link = lastItem.link;
		active.link.classList.add(activeClass);

		function inView(rect) {
			let viewportHeight = document.documentElement.clientHeight;
			let activeViewportHeight = viewportHeight * 0.4;

			return rect.top <= activeViewportHeight && rect.bottom >= activeViewportHeight;
		}
	});

	function clearActive() {
		if (!active.link || !active.section) {
			return;
		}

		active.link.classList.remove(activeClass);
		active.section.classList.remove(activeClass);

		active.link = undefined;
		active.section = undefined;
	}
}
